module.exports = __webpack_public_path__ + "img/instagram_inktober_final.accbd7dc.jpg";